import { BiteLogKioskEvent } from './bite_log_kiosk_event.js';

export function name(event: BiteLogKioskEvent): string {
  switch (event) {
    case BiteLogKioskEvent.OK:
      return 'ok';
    case BiteLogKioskEvent.Update:
      return 'update';
    case BiteLogKioskEvent.TurnedOff:
      return 'turned-off';
    case BiteLogKioskEvent.TurnedOffIndefinitely:
      return 'turned-off-indefinitely';
    case BiteLogKioskEvent.TurnedOn:
      return 'turned-on';
    case BiteLogKioskEvent.ApnSentDeprecated:
      return 'notification-sent';
    case BiteLogKioskEvent.ApnSendErrorDeprecated:
      return 'notification-send-error';
    case BiteLogKioskEvent.PushSent:
      return 'push-sent';
    case BiteLogKioskEvent.PushSendError:
      return 'push-send-error';
    case BiteLogKioskEvent.StatusMissing:
      return 'status-missing';
    case BiteLogKioskEvent.StatusRecovered:
      return 'status-recovered';
    case BiteLogKioskEvent.EnabledAda:
      return 'enabled-ada';
    case BiteLogKioskEvent.EnableAdaError:
      return 'enable-ada-error';
    case BiteLogKioskEvent.DisabledAda:
      return 'disabled-ada';
    case BiteLogKioskEvent.DisableAdaError:
      return 'disable-ada-error';
    case BiteLogKioskEvent.MovedMDMGroup:
      return 'moved-mdm-group';
    case BiteLogKioskEvent.MoveMDMGroupError:
      return 'move-mdm-group-error';
    case BiteLogKioskEvent.DeviceReboot:
      return 'device-reboot';
    case BiteLogKioskEvent.DeviceRebootError:
      return 'device-reboot-error';
    case BiteLogKioskEvent.Inactive:
      return 'inactive (no sales in the last hour)';
  }
}
